import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import DateOrMonthFilter from './DateOrMonthFilter'
import {
  getTimersGroupedByUserAndProjectAsync,
  getTimersByMonth
} from '../../api/Timer.api';
import { Timer } from '../../model/Timer.model';
import dayjs from 'dayjs';

const AttendancePage = () => {
  const [viewMode, setViewMode] = useState<'projects' | 'dates'>('projects');
  const [projectData, setProjectData] = useState<any[]>([]);
  const [dateData, setDateData] = useState<any[]>([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedDayProjects, setSelectedDayProjects] = useState<Timer[]>([]);
  const [filterStartDate, setFilterStartDate] = useState<string | undefined>();
  const [filterEndDate, setFilterEndDate] = useState<string | undefined>();
  const [filterMonth, setFilterMonth] = useState<string | undefined>();
  const handleFilter = (start?: string, end?: string, month?: string) => {
    setFilterStartDate(start);
    setFilterEndDate(end);
    setFilterMonth(month);
  };

  useEffect(() => {
    const startOfMonth = dayjs().startOf('month').format('YYYY-MM-DD');
    const today = dayjs().format('YYYY-MM-DD');
    handleFilter(startOfMonth, today, undefined);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userId = sessionStorage.getItem('userId');

        if (!userId) return;

        if (viewMode === "projects") {
          const res = await getTimersGroupedByUserAndProjectAsync(userId);
          const projectDict = res.data[1]; // החלק עם הפרויקטים
          setProjectData(projectDict);
          // או res אם כבר מוחזר data בלבד
        } else if (viewMode === "dates" && filterStartDate && filterEndDate) {
          // במקרה הזה נניח שפונקציה דורשת userId + תאריכים
          const month = new Date(filterStartDate).getMonth() + 1;
          const year = new Date(filterStartDate).getFullYear();
          const res = await getTimersByMonth(userId, month, year);

          setDateData(res);
          const groupedByDate: { [date: string]: Timer[] } = {};

          res.forEach((timer: Timer) => {
            const date = String(timer.startTime).split("T")[0];

            if (!date) return;
            if (!groupedByDate[date]) {
              groupedByDate[date] = [];
            }
            groupedByDate[date].push(timer);
          });

          const groupedArray = Object.entries(groupedByDate).map(([dateMonth, workeLog]) => ({
            dateMonth,
            workeLog,
          }));

          setDateData(groupedArray);

        }
      } catch (error) {
        console.error("שגיאה בטעינת נתוני נוכחות:", error);
      }
    };

    fetchData();
  }, [viewMode, filterStartDate, filterEndDate, filterMonth]);
  useEffect(() => {

  }, [filterStartDate, filterEndDate]);
  useEffect(() => {
  }, [dateData]);
  const getMinutesFromDurationString = (duration: string): number => {
    const [hours, minutes, seconds] = duration.split(":").map(Number);
    return hours * 60 + minutes + Math.floor(seconds / 60);
  };

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('he-IL');
  };
  return (
    <Box sx={{ padding: 4, direction: 'rtl' }}>
      <Typography variant="h4" align="center">דו"ח נוכחות</Typography>
      <DateOrMonthFilter onFilter={handleFilter} />
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, my: 3 }}>
        <Button
          variant={viewMode === 'projects' ? 'contained' : 'outlined'}
          onClick={() => setViewMode('projects')}
        >
          לפי פרויקטים
        </Button>
        <Button
          variant={viewMode === 'dates' ? 'contained' : 'outlined'}
          onClick={() => setViewMode('dates')}
        >
          נוכחות שעות
        </Button>
      </Box>
      {/* לפי פרויקטים */}
      {viewMode === 'projects' && Object.entries(projectData).map(([projectId, timers], i) => {
        const totalMinutes = timers.reduce((sum, t) => sum + getMinutesFromDurationString(t.duration || '0:00:00')
          , 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const projectName = timers[0]?.projectName || 'פרויקט ללא שם';

        return (
          <Box key={i} sx={{ border: '1px solid #ccc', borderRadius: 2, p: 2, my: 1 }}>
            <Typography> פרויקט: {projectName}</Typography>
            <Typography> סך שעות: {hours}:{minutes.toString().padStart(2, '0')}</Typography>
          </Box>
        );
      })}

      {/* לפי תאריכים */}
      {viewMode === 'dates' && dateData.map((day: { dateMonth: string, workeLog: Timer[] }, i) => {
        const totalMinutes = day.workeLog.reduce((sum, t) => sum + (parseInt(t.duration || '0')), 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const uniqueProjects = [...new Set(day.workeLog.map(t => t.projectName))];
        return (
          <Box key={i} sx={{ border: '1px solid #ccc', borderRadius: 2, p: 2, my: 1 }}>
            <Typography> תאריך: {formatDate(day.dateMonth)}</Typography>
            <Typography> סה"כ שעות: {`${hours}:${minutes.toString().padStart(2, '0')}`}</Typography>
            <Typography> מספר פרויקטים: {uniqueProjects.length}</Typography>
            <Button onClick={() => { setSelectedDayProjects(day.workeLog); setPopupOpen(true); }}>
              הצג פרויקטים
            </Button>
          </Box>
        );
      })}
      {/* פופ-אפ פרויקטים לאותו יום */}
      <Dialog open={popupOpen} onClose={() => setPopupOpen(false)}>
        <DialogTitle>פרויקטים ביום זה</DialogTitle>
        <DialogContent>
          <List>
            {selectedDayProjects.map((t, i) => (
              <ListItem key={i}>
                <ListItemText
                  primary={`:file_folder: ${t.projectName}`}
                  secondary={`:stopwatch: משך: ${t.duration} דקות`}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
export default AttendancePage;